import { DurationUnitEnum } from '../../../shared/enums/duration-unit.enum';
import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';
import { PricingTierItemDto } from '../../../shared/modules/pricing-tier-items/dtos/pricing-tier-item.dto';

/**
 * Asset quotation DTO
 */
export class AssetQuotationDto {
  /**
   * Asset uuid
   */
  assetUuid!: string;

  /**
   * Duration unit
   */
  durationUnit!: DurationUnitEnum;

  /**
   * Duration
   */
  @TransformFloat()
  duration!: number;

  /**
   * Date from
   */
  dateFrom!: Date;

  /**
   * Date to
   */
  dateTo!: Date;

  /**
   * Computed total net amount
   */
  @TransformFloat()
  computedTotalNet?: number;

  /**
   * Computed total tax amount
   */
  @TransformFloat()
  computedTotalTax?: number;

  /**
   * Computed total gross amount
   */
  @TransformFloat()
  computedTotalGross?: number;

  /**
   * Computed standard subtotal
   */
  @TransformFloat()
  computedStandardNet?: number;

  @TransformFloat()
  computedStandardTax?: number;

  @TransformFloat()
  computedStandardGross?: number;

  /**
   * Computed extras subtotal
   */
  @TransformFloat()
  computedExtrasNet?: number;

  @TransformFloat()
  computedExtrasTax?: number;

  @TransformFloat()
  computedExtrasGross?: number;

  /**
   * Computed discount net amount
   */
  @TransformFloat()
  computedDiscountNet?: number;

  /**
   * Computed discount tax amount
   */
  @TransformFloat()
  computedDiscountTax?: number;

  /**
   * Computed discount gross amount
   */
  @TransformFloat()
  computedDiscountGross?: number;

  /**
   * Vehicle category discount percentage (0-100)
   */
  @TransformFloat()
  standardDiscountPercentage?: number;

  /**
   * Vehicle-category deposit amount for the quoted duration. Always present
   * and independent of the tenant reservation strategy.
   */
  @TransformFloat()
  computedDepositAmount?: number;

  /**
   * Computed savings amount based on the highest tiered per-unit rate for the full duration
   */
  @TransformFloat()
  computedSavingsAmount?: number;

  /**
   * Computed savings as a percentage of that tiered reference total
   */
  @TransformFloat()
  computedSavingsPercentage?: number;

  /**
   * Original standard amount (standard gross + savings)
   */
  @TransformFloat()
  computedOriginalStandardAmount?: number;

  /**
   * Pricing items
   */
  pricingItems?: PricingTierItemDto[];
}
